import React from 'react';
import ExperienceCard from "./ui/ExperienceCard";
import { default as boroks } from "../assets/exp/borok's-development.webp";
import { default as novanexus } from "../assets/exp/novanexus.webp";
import { default as spideymc } from "../assets/exp/spigotmc.webp";
import { default as defenderCaveImg } from "../assets/exp/defendercave.png";
import { default as arcaneStudioImg } from "../assets/exp/arcanestudioimg.png";
import { default as infinitePluginsImg } from "../assets/exp/infinitepluginsimg.png";
import { default as raidhubimg } from "../assets/exp/raidhub-hosting.png";
import { default as atomicHiveImg } from "../assets/exp/atomic-hive.webp";

const Experience = () => {
  const defenderCave = [
    "Founder & Creator of the development server, basically a hub for my public plugins.",
    "This was created to build a community and provide support for all my public plugins.",
    "Every seen 2022, this server has gained a lot of memebers and now as of Feb. 2025 sits at 300+ members."
  ];

  return (
    <div
      id="experience"
      className="mx-auto flex flex-col justify-center gap-8 px-4 sm:px-6 py-24 md:items-center max-w-3xl"
    >
      <div className="text-center space-y-2 mb-6">
        <h2 className="text-[#55ff55] font-mono text-xs uppercase tracking-widest font-bold">Career History</h2>
        <h1 className="text-3xl font-extrabold text-white sm:text-4xl tracking-tight select-none">
          Experience
        </h1>
      </div>

      <ExperienceCard
        logo={defenderCaveImg}
        name="Defender's Cave"
        job="Founder & Developer"
        duration="July 2022 - Present"
        skills={defenderCave}
      />
      
      <ExperienceCard
        logo={infinitePluginsImg}
        name="InfinitePlugins (formely PM2 Plugins)"
        duration="July 2024 - April 2026"
        job="Project(s) Developer"
        skills={[
          "I have worked on multiple projects and provided support them if they were pulicly available.",
          "Such as, GUIPlus v3 (previously, InfiniteGUI) - I have made the plugin from scratch and it is publicly available.",
          "InfiniteVehicles - A plugin that adds vehicles to Minecraft.",
          "Others plugins: InfiniteCrates, SpecializedCrates [discontinued, as far as I know], and more that are not publicly available yet."
        ]}
      />

      <ExperienceCard
        logo={novanexus}
        name="NovaNexus"
        job="Lead Developer"
        duration="Jan. 2024 - Present"
        skills={[
          "Lead developer on the server. Generally work on the system(s) of the server.",
          "I work on writing high quality and optimized code as well as server management on the work.",
          "I have made many complex features during the duration of my work, and continue to do so.",
          "Some of the complex features include a in-game main menu with animated background that moves when you move the in-game visual cursor, this is handled mostly via packets and display entity manipulation.",
          "Another notable feature I have created is the, perks system.",
          "I have wrote the code for most of the backend for the server as well.",
          "Server is currently in Closed-Alpha"
        ]}
      />

      <ExperienceCard
        logo={raidhubimg}
        name="RaidHub Hosting"
        job="SysAdmin"
        duration="2025 - Present"
        skills={[
          "I manage the backend system, including the panel, websites and anything else server-related",
          "That is basically about it for my role. RaidHub Hosting is a fairly new hosting and I am just the SysAdmin and NOT a owner or co-owner.",
          "You may buy their services at your own risk. Owner of RaidHub Hosting is 5KFubi, he is a friend."
        ]}
      />

      <ExperienceCard
        logo={atomicHiveImg}
        name="AtomicHive"
        job="Developing Core Plugins"
        duration="October 2023 - December 2025"
        skills={[
          "I worked on the core Skyblock plugin for the server.",
          "But the owner eventually got busy and decided to not continue the project."
        ]}
      />

      <ExperienceCard
        logo={spideymc}
        name="SpideyMC"
        job="Founder & Developer"
        duration="June 2021 - June 2022"
        skills={[
          "I was the Founder and the only Developer on this SMP project.",
          "I also coded custom plugins for it when it was open.",
          "The server was eventually closed due to lack of motivation and players."
        ]}
      />

      <ExperienceCard
        logo={boroks}
        name="Boroks Development"
        job="Freelancer"
        duration="Nov. 2023 - Present"
        skills={[
          "Freelancer in the organization.",
          "I have worked on multiple projects with multiple clients in this organization.",
          "Including but not limited to, a system for mining and combat for a custom Skyblock server.",
          "The organization is under a full rework as of now."
        ]}
      />

      <ExperienceCard
        logo={arcaneStudioImg}
        name="Arcane Studio"
        job="Freelancer"
        duration="2024 - Present"
        skills={[
          "This is another freelancing studio that I am a part of.",
          "Here too, I have worked on multiple projects with various clients.",
          "Including but not limited to a plugin that adds skills & features from the game, World of Warcraft.",
          "I am available for comission on the studio server."
        ]}
      />
    </div>
  );
};

export default Experience;
